import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';

import { AppRoute } from '@/common/app/routes';
import { NavigateItem } from '@/components/ui/NavigateItem/NavigateItem';
import { Picture } from '@/components/ui/Picture/Picture';

import css from './styles.module.scss';

import folderPng from '/img/icons/folder.png';
import folderWebp from '/img/icons/folder.webp';

interface LotteryHistoryNavLinkProps {
  className?: string;
}

const LotteryHistoryNavLink: FC<LotteryHistoryNavLinkProps> = ({
  className,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <NavigateItem
      label={t('Winners')}
      className={cn(className)}
      parentClassName={cn(css.effects, 'flex items-center justify-center')}
      onClick={() => navigate(AppRoute.LOTTERY + '/history')}
    >
      <Picture
        img={folderPng}
        webp={folderWebp}
        alt="info"
        className="size-[36px]"
      />
    </NavigateItem>
  );
};

export { LotteryHistoryNavLink };
